import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getDocumentCounts } from "@/api/documents";
import { getEmailCounts } from "@/api/emails";
import type { FilterState } from "@/types/domain";

/**
 * Per-tab counts. Mode-aware: fetches email counts in Emails mode,
 * document counts in Documents mode. The two endpoints share the same
 * response shape (``ListTabCounts``), so downstream consumers don't
 * care which is which.
 */
export function useListCounts(filters: FilterState) {
  return useQuery({
    queryKey: ["listCounts", filters],
    queryFn: () =>
      filters.mode === "emails"
        ? getEmailCounts(filters)
        : getDocumentCounts(filters),
    placeholderData: keepPreviousData,
    staleTime: 10_000,
  });
}
